import { PoolList } from './';
import PoolDetail from './PoolDetail'
export default {
  path: 'farms',
  childRoutes: [
    { path: '/', component: PoolList, isIndex: true },
    { path: ':poolId', component: PoolDetail, isIndex: false },
  ]
};
